import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { isE2eBypassEnabled } from './e2e-bypass';

@Component({
  selector: 'app-callback',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '', // optional: "Signing you in..."
})
export class CallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private msalService: MsalService,
  ) {}

  async ngOnInit() {
    if (!isE2eBypassEnabled()) {
      // MSAL reloads to the page that started the login; this only settles if it didn't.
      await firstValueFrom(this.msalService.handleRedirectObservable()).catch(() => null);
    }
    await this.router.navigateByUrl('/');
  }
}
